module.exports = __webpack_public_path__ + "img/p2-75.ddebbfc5.png";